// Реестр содержимого панелей. Стопка панелей живёт в адресе (?p=вид:id) и рисуется каркасом
// (PanelStack), а что именно внутри — знает раздел. Реестр разводит эти две ответственности:
// каркас не импортирует модули (иначе полоса разделов потянула бы за собой весь код разделов),
// модуль не рисует вторую стопку поверх каркасной.
//
// Регистрация — один вызов на панель при загрузке модуля раздела. Вида нет в реестре —
// каркас честно говорит, что содержимое ещё не приехало, а не показывает белый прямоугольник.

import type { ReactNode } from 'react';

export interface PanelContentProps {
  /** Идентификатор из адреса: сущность панели либо контекст мастера. */
  id: string;
  /** Закрыть верхнюю панель — то же, что Esc. */
  onClose: () => void;
}

export interface PanelDef {
  /** Заголовок в шапке панели. */
  title: (id: string) => string;
  render: (props: PanelContentProps) => ReactNode;
}

const registry = new Map<string, PanelDef>();

export function registerPanel(view: string, def: PanelDef): void {
  registry.set(view, def);
}

export function panelDef(view: string): PanelDef | undefined {
  return registry.get(view);
}
